import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PaypalButton from '../../../../../01_atoms/Payments/PaypalButton';
import {
  BACKEND_URL,
  PAYPAL_CLIENT_LIVE,
  PAYPAL_CLIENT_TEST,
  RG,
  SD,
} from '../../../../../../utils/constants';
import {
  PAYMENT_MODE,
  PAYMENT_MODE_LIVE,
  PAYPAL_DONATION_PAYLOAD,
  PAYPAL_SUBSCRIPTION_PAYLOAD,
} from '../../../../../../utils/payments';
import unexpectedErrorMessage from '../../../../../../utils/unexpectedErrorMessage';

const PayPalPaymentButton = ({
  onSuccessPayment,
  paymentMethodId,
  onError,
  onCancel,
  onClick,
  donationType,
  disabled,
  onBeforeAuthentication,
}) => {
  const [isError, setError] = useState(false);

  return (
    <PaypalButton
      client={{
        sandbox: PAYPAL_CLIENT_TEST,
        production: PAYPAL_CLIENT_LIVE,
      }}
      env={PAYMENT_MODE === PAYMENT_MODE_LIVE ? 'production' : 'sandbox'}
      isSubscription={donationType === RG}
      payload={donationType === RG ? PAYPAL_SUBSCRIPTION_PAYLOAD : PAYPAL_DONATION_PAYLOAD}
      backendURL={BACKEND_URL}
      onSuccess={onSuccessPayment}
      disabled={disabled}
      onCancel={onCancel}
      onError={() => {
        // PayPal error can have multiple layers each of which will trigger onError
        // callback. Ensure we show error on a screen only once.
        if (!isError) {
          onError({
            paymentMethodId,
            message:
              "Sorry, we couldn't complete your donation. Please review your details and try again or select an alternative payment method.",
            subline: unexpectedErrorMessage(),
            additionalMessage: '',
          });
          setError(true);
        }
      }}
      onClick={() => {
        onClick();
        // Reset error state on click.
        setError(false);
      }}
      onBeforeAuthentication={onBeforeAuthentication}
      paymentGateway={paymentMethodId}
      style={{
        label: 'paypal',
        size: 'responsive',
        shape: 'rect',
        color: 'blue',
        tagline: false,
        height: 50,
      }}
    />
  );
};

PayPalPaymentButton.propTypes = {
  donationType: PropTypes.oneOf([SD, RG]).isRequired,
  onSuccessPayment: PropTypes.func.isRequired,
  paymentMethodId: PropTypes.string.isRequired,
  onError: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  onBeforeAuthentication: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default PayPalPaymentButton;
